<template>
	<!-- 楼道堆物 -->
  <process-list :singleState='9'/>
</template>

<script>
export default {
	name: "dwdlPage",
	components: {
    processList : async () => import('@/components/processList.vue')
  },
	data() {
		return {

		};
	},
	created() {

	},

	mounted() {

	},

};
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/pages/pileThing/pileThing.vue